import { Clock, ListChecks, Package } from "lucide-react";

export interface QuickInfoData {
  deliveryTime?: string;
  included?: string;
  notIncluded?: string;
  deliverable?: string;
}

interface ServiceQuickInfoProps {
  data?: QuickInfoData;
}

const ServiceQuickInfo = ({ data }: ServiceQuickInfoProps) => {
  const cards = [
    {
      icon: Clock,
      label: "Plazo de entrega",
      value: data?.deliveryTime ?? "Setup en X días · Entregables mensuales recurrentes",
    },
    {
      icon: ListChecks,
      label: "Qué incluye y qué no",
      value:
        data?.included && data?.notIncluded
          ? `Incluye: ${data.included}. No incluye: ${data.notIncluded}.`
          : "Incluye: [placeholder de lo que sí entra]. No incluye: [placeholder de lo que queda fuera].",
    },
    {
      icon: Package,
      label: "Entregable final",
      value: data?.deliverable ?? "[Placeholder del entregable final que recibe el cliente]",
    },
  ];

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-5xl mx-auto grid gap-5 md:grid-cols-3">
        {cards.map(({ icon: Icon, label, value }) => (
          <div
            key={label}
            className="rounded-2xl border border-border bg-card p-6 hover:border-primary/40 transition-colors flex flex-col"
          >
            <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-4">
              <Icon size={20} />
            </div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground font-body mb-2">
              {label}
            </div>
            <p className="text-sm text-foreground/90 leading-relaxed">{value}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceQuickInfo;
